module.exports = __webpack_public_path__ + "static/media/08.2395f802.png";